import { View, StyleSheet } from "@react-pdf/renderer";
import { SummaryDto } from "../../app/models/summary/summaryDto";
import LegacyReceiptTableHeader from "./LegacyReceiptTableHeader";
import LegacyReceiptTableRow from "./LegacyReceiptTableRow";

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 24
    }
});

interface Props {
    legacyTitles: string[] | null;
    legacySummaryData: SummaryDto[][] | null;
}

const LegacyReceiptItemsTable = ({ legacyTitles, legacySummaryData }: Props) => {
    return (
        <View style={styles.tableContainer}>
            <LegacyReceiptTableHeader legacyTitles={legacyTitles} />
            <LegacyReceiptTableRow legacySummaryData={legacySummaryData} />
        </View>
    )
};

export default LegacyReceiptItemsTable;